import React from 'react';

export const PriorityBadge = ({ priority }) => {
  const colors = {
    high: 'bg-red-100 text-red-700 border border-red-200',
    medium: 'bg-yellow-100 text-yellow-700 border border-yellow-200',
    low: 'bg-blue-100 text-blue-700 border border-blue-200'
  };

  return (
    <span className={`px-2 py-0.5 text-xs rounded-full font-medium ${colors[priority]}`}>
      {priority.charAt(0).toUpperCase() + priority.slice(1)}
    </span>
  );
};

export const StatusBadge = ({ status }) => {
  const colors = {
    open: 'bg-blue-100 text-blue-700 border border-blue-200',
    'in-progress': 'bg-yellow-100 text-yellow-700 border border-yellow-200',
    resolved: 'bg-green-100 text-green-700 border border-green-200',
    closed: 'bg-gray-100 text-gray-700 border border-gray-200'
  };

  return (
    <span className={`px-2 py-0.5 text-xs rounded-full font-medium ${colors[status]}`}>
      {status.split('-').map(word => word.charAt(0).toUpperCase() + word.slice(1)).join(' ')}
    </span>
  );
}; 